export const types = {
  GET_SUBCONTRACTORS: 'subcontractors/GET_SUBCONTRACTORS',
  GET_SUBCONTRACTORS_SUCCESS: 'subcontractors/GET_SUBCONTRACTORS_SUCCESS',
  GET_SUBCONTRACTORS_FAILED: 'subcontractors/GET_SUBCONTRACTORS_FAILED',
};
